var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0V6.68464C8 7.09377 8.15804 7.48614 8.43934 7.77543C8.72064 8.06473 9.10218 8.22725 9.5 8.22725H16V18.5113C16 19.0568 15.7893 19.58 15.4142 19.9657C15.0391 20.3514 14.5304 20.5681 14 20.5681H2C1.46957 20.5681 0.960859 20.3514 0.585786 19.9657C0.210714 19.58 0 19.0568 0 18.5113V2.05681C0 1.51131 0.210714 0.988154 0.585786 0.602426C0.960859 0.216699 1.46957 0 2 0H8ZM7.011 10.1277C6.77162 11.6941 5.97513 13.1131 4.776 14.1097C3.889 14.8461 4.7 16.291 5.764 15.8704C7.20282 15.3005 8.79618 15.3005 10.235 15.8704C11.299 16.292 12.11 14.8471 11.223 14.1097C10.0239 13.1131 9.22738 11.6941 8.988 10.1277C8.811 8.96976 7.188 8.96873 7.011 10.1277ZM8 12.6525L8.806 14.0861H7.196L8 12.6525ZM10 0.0442215C10.3789 0.126859 10.7263 0.320854 11 0.602646L15.414 5.14203C15.688 5.42353 15.8766 5.7808 15.957 6.17044H10V0.0442215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export_icon.adc25fbd4863861c64de28d690197d95.svg";
export { ForwardRef as ReactComponent };